<template>
    <div class="all-info-container">
        <a href="javascript:void(0)" v-on:click="print()">
            {{$t('protegeAllInfo.printLink')}}
        </a>
        <div class="all-info-container" id="printable" :ref="'printable' + protege.profile.id">
            <div class="header">
                <div class="row">
                    <div class="col">
                        <guardian-title-component :title="fullname"
                                                  :subtitle="$t('print.title')"></guardian-title-component>
                    </div>
                </div>
            </div>
            <div class="profile">
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('profile.basicInformation.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="firstname-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.firstname')"
                                                  label-for="firstname-input">
                                        <b-form-input id="firstname-input"
                                                      name="firstname-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.firstname"
                                                      required
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="lastname-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.lastname')"
                                                  label-for="lastname-input">
                                        <b-form-input id="lastname-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.lastname"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="address-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.address')"
                                                  label-for="address-input">
                                        <b-form-input id="address-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.address"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="address-extra-line-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.addressExtraInformation')"
                                                  label-for="address-extra-line-input">
                                        <b-form-input id="address-extra-line-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.extraAddressLine"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="zipcode-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.zipcode')"
                                                  label-for="zipcode-input">
                                        <b-form-input id="firstname-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.zipcode"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="city-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.basicInformation.city')"
                                                  label-for="city-input">
                                        <b-form-input id="city-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.city"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('profile.contactInformation.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="email-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.contactInformation.email')"
                                                  label-for="email-input">
                                        <b-form-input id="email-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.email"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="mobile-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.contactInformation.mobile')"
                                                  label-for="mobile-input">
                                        <b-form-input id="mobile-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.mobile"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="phone-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.contactInformation.phone')"
                                                  label-for="phone-input">
                                        <b-form-input id="phone-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.phone"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="website-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.contactInformation.website')"
                                                  label-for="website-input">
                                        <b-form-input id="website-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.website"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('profile.detailInformation.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="profession-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.profession')"
                                                  label-for="profession-input">
                                        <b-form-input id="profession-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.profession"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="employer-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.employer')"
                                                  label-for="employer-input">
                                        <b-form-input id="employer-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.employer"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="ahv-number-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.ahvNumber')"
                                                  label-for="ahv-number-input">
                                        <b-form-input id="ahv-number-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.ahvNumber"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="birthdate-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.birthdate')"
                                                  label-for="birthdate-input">
                                        <datepicker v-model="protege.profile.birthdate" id="birthdate-input"
                                                    class="o-form" :format="'dd.MM.yyyy'"></datepicker>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="place-of-origin-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.placeOfOrigin')"
                                                  label-for="place-of-origin-input">
                                        <b-form-input id="place-of-origin-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.placeOfOrigin"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="marital-status-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.maritalStatus')"
                                                  label-for="marital-status-input">
                                        <b-form-input id="marital-status-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.maritalStatus"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="health-insurance-1-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.healthInsurance1')"
                                                  label-for="health-insurance-1-input">
                                        <b-form-input id="health-insurance-1-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.healthInsurance1"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="health-insurance-2-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.detailInformation.healthInsurance2')"
                                                  label-for="health-insurance-2-input">
                                        <b-form-input id="health-insurance-2-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.healthInsurance2"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('profile.furtherInformation.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="form-group"
                                                  class="o-label"
                                                  :label="$t('profile.furtherInformation.organDonor')"
                                                  label-for="organ-donor-input">
                                        <b-form-input id="organ-donor-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="organDonor"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="form-group"
                                                  class="o-label"
                                                  :label="$t('profile.furtherInformation.patientsProvision')"
                                                  label-for="firstname-input">
                                        <b-form-input id="firstname-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="patientsProvision"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="religion-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.furtherInformation.religion')"
                                                  label-for="religion-input">
                                        <b-form-input id="religion-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.religion"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col">
                                    <b-form-group id="confession-form-group"
                                                  class="o-label"
                                                  :label="$t('profile.furtherInformation.confession')"
                                                  label-for="confession-input">
                                        <b-form-input id="confession-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.profile.confession"
                                                      placeholder="">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="burial">
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('burial.meta')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group v-if="protege.burial.typeOfBurial !== 'Andere Art'"
                                                  id="burial-form-group"
                                                  class="o-label"
                                                  :label="$t('burial.typeOfBurial.title')"
                                                  label-for="burial-input">
                                        <b-form-input id="burial-input"
                                                      name="burial-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.burial.typeOfBurial"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="protege.burial.typeOfGrave !== 'Andere Art'"
                                                  id="grave-form-group"
                                                  class="o-label"
                                                  :label="$t('burial.typeOfGrave.title')"
                                                  label-for="grave-input">
                                        <b-form-input id="grave-input"
                                                      name="grave-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.burial.typeOfGrave"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="protege.burial.typeOfBurial === 'Andere Art'"
                                                  id="grave-form-group"
                                                  class="o-label"
                                                  :label="$t('burial.typeOfBurial.title')"
                                                  label-for="grave-input">
                                        <b-form-input id="grave-input"
                                                      name="grave-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.burial.otherBurialText"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="protege.burial.typeOfGrave === 'Andere Art'"
                                                  id="grave-form-group"
                                                  class="o-label"
                                                  :label="$t('burial.typeOfGrave.title')"
                                                  label-for="grave-input">
                                        <b-form-input id="grave-input"
                                                      name="grave-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.burial.otherGraveText"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ceremony">
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('ceremony.location.ceremony-title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group v-if="protege.ceremony.locationTypeCeremony === 'church'"
                                                  id="ceremony-restaurant-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.location.church')"
                                                  label-for="ceremony-restaurant-input">
                                        <b-form-input id="ceremony-restaurant-input"
                                                      name="ceremony-restaurant-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.churchTextCeremony"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="protege.ceremony.locationTypeCeremony === 'nature'"
                                                  id="ceremony-club-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.location.nature')"
                                                  label-for="ceremony-club-input">
                                        <b-form-input id="ceremony-club-input"
                                                      name="ceremony-club-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.natureTextCeremony"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="protege.ceremony.locationTypeCeremony === 'restaurantClub'"
                                                  id="ceremony-cabin-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.location.restaurantClub')"
                                                  label-for="ceremony-cabin-input">
                                        <b-form-input id="ceremony-cabin-input"
                                                      name="ceremony-cabin-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.restaurantClubTextCeremony"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="protege.ceremony.locationTypeCeremony === 'otherLocation'"
                                                  id="ceremony-other-location-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.location.other')"
                                                  label-for="ceremony-other-location-input">
                                        <b-form-input id="ceremony-other-location-input"
                                                      name="ceremony-other-location-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.locationOtherTextCeremony"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('ceremony.location.observance-title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group v-if="protege.ceremony.locationTypeObservance === 'church'"
                                                  id="ceremony-restaurant-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.location.church')"
                                                  label-for="ceremony-restaurant-input">
                                        <b-form-input id="ceremony-restaurant-input"
                                                      name="ceremony-restaurant-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.churchTextObservance"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="protege.ceremony.locationTypeObservance === 'nature'"
                                                  id="ceremony-club-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.location.nature')"
                                                  label-for="ceremony-club-input">
                                        <b-form-input id="ceremony-club-input"
                                                      name="ceremony-club-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.natureTextObservance"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="protege.ceremony.locationTypeObservance === 'restaurantClub'"
                                                  id="ceremony-cabin-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.location.restaurantClub')"
                                                  label-for="ceremony-cabin-input">
                                        <b-form-input id="ceremony-cabin-input"
                                                      name="ceremony-cabin-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.restaurantClubTextObservance"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group v-if="protege.ceremony.locationTypeObservance === 'otherLocation'"
                                                  id="ceremony-other-location-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.location.other')"
                                                  label-for="ceremony-other-location-input">
                                        <b-form-input id="ceremony-other-location-input"
                                                      name="ceremony-other-location-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.locationOtherTextObservance"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('ceremony.decoration.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="ceremony-flower-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.decoration.ceremonyFlowers')"
                                                  label-for="ceremony-flower-input">
                                        <b-form-input id="ceremony-flower-input"
                                                      name="ceremony-flower-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.ceremonyFlowers"
                                                      required
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group id="ceremony-observance-flower-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.decoration.observanceFlowers')"
                                                  label-for="ceremony-observance-flower-input">
                                        <b-form-input id="ceremony-observance-flower-input"
                                                      name="ceremony-observance-flower-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.observanceFlowers"
                                                      required
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group id="ceremony-decoration-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.decoration.observanceDecoration')"
                                                  label-for="ceremony-decoration-input">
                                        <b-form-input id="ceremony-decoration-input"
                                                      name="ceremony-decoration-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.observanceDecoration"
                                                      required
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group id="ceremony-decoration-misc-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.decoration.decorationMisc')"
                                                  label-for="ceremony-decoration-misc-input">
                                        <b-form-input id="ceremony-decoration-misc-input"
                                                      name="ceremony-decoration-misc-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.decorationMisc"
                                                      required
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('ceremony.food.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="ceremony-apero-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.food.apero')"
                                                  label-for="ceremony-apero-input">
                                        <b-form-input id="ceremony-apero-input"
                                                      name="ceremony-apero-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.apero"
                                                      required
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group id="ceremony-menu-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.food.menu')"
                                                  label-for="ceremony-menu-input">
                                        <b-form-input id="ceremony-menu-input"
                                                      name="ceremony-menu-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.menu"
                                                      required
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group id="ceremony-beverages-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.food.beverages')"
                                                  label-for="ceremony-beverages-input">
                                        <b-form-input id="ceremony-beverages-input"
                                                      name="ceremony-decoration-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.beverages"
                                                      required
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group id="ceremony-dishes-misc-form-group"
                                                  class="o-label"
                                                  :label="$t('ceremony.food.dishesMisc')"
                                                  label-for="ceremony-dishes-misc-input">
                                        <b-form-input id="ceremony-dishes-misc-input"
                                                      name="ceremony-dishes-misc-input-name"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.ceremony.dishesMisc"
                                                      required
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('ceremony.music.title')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                        <b>{{ $t('ceremony.music.ceremonyMusic') }}</b>
                                        <ul>
                                            <li v-for="music in protege.musics.ceremonyMusics" :key="music.id">
                                                {{music.musicText}}
                                            </li>
                                        </ul>
                                    <b>{{ $t('ceremony.music.ceremonyBand') }}</b>
                                    <ul>
                                        <li v-for="music in protege.musics.ceremonyBands" :key="music.id">
                                            {{music.musicText}}
                                        </li>
                                    </ul>
                                    <b>{{ $t('ceremony.music.observanceMusic') }}</b>
                                    <ul>
                                        <li v-for="music in protege.musics.observanceMusics" :key="music.id">
                                            {{music.musicText}}
                                        </li>
                                    </ul>
                                    <b>{{ $t('ceremony.music.observanceBand') }}</b>
                                    <ul>
                                        <li v-for="music in protege.musics.observanceBands" :key="music.id">
                                            {{music.musicText}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="guestlist">
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('guestlist.meta')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-table id="contacts-table"
                                             hover
                                             small
                                             fixed
                                             :items="protege.guestlist"
                                             :per-page="perPage"
                                             :current-page="currentPage"
                                             :total-rows="totalRows"
                                             :fields="computedFields">
                                        <template slot="HEAD_firstname" slot-scope="" class="o-thead">
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pets">
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('pets.meta')"></card-title-component>
                        <div class="card-content">
                            <div v-for="(pet) in protege.pets" :key="pet.id">
                                <all-info-pet-component :name="pet.name"
                                                        :species="pet.species"
                                                        :transponderId="pet.transponderId"
                                                        :birthdate="pet.birthdate"
                                                        :veterinarian="pet.veterinarian"
                                                        :custodyAfterDeath="pet.custodyAfterDeath"
                                                        :notes="pet.notes">
                                </all-info-pet-component>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="documents">
                <div class="row">
                    <div class="col">
                        <card-title-component :title="$t('speeches.meta')"></card-title-component>
                        <div class="card-content">
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="funeral-oration-form-group"
                                                  class="o-label"
                                                  :label="$t('speeches.persons.burialSpeaker')"
                                                  label-for="funeral-oration-input">
                                        <b-form-input id="funeral-oration-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.speeches.burialSpeaker"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <b-form-group id="funeral-ceremony-speaker-form-group"
                                                  class="o-label"
                                                  :label="$t('speeches.persons.ceremonySpeaker')"
                                                  label-for="burial-speaker-input">
                                        <b-form-input id="burial-speaker-input"
                                                      class="o-form"
                                                      type="text"
                                                      v-model="protege.speeches.ceremonySpeaker"
                                                      placeholder=""
                                                      disabled>
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {
        PROTEGES_ACTION_GET_PROTEGE_ALL_INFO,
        PROTEGES_NAMESPACE
    } from '../../store/modules/proteges-types'
    import CardTitleComponent from '../ui/card/CardTitleComponent'
    import GuardianTitleComponent from './GuardianTitleComponent'
    import AllInfoPetComponent from './AllInfoPetComponent'
    import Datepicker from 'vuejs-datepicker'
    import i18n from '../../assets/i18n/lang'

    export default {
        name: 'GuardianAllInfo',
        components: {
            'guardian-title-component': GuardianTitleComponent,
            'card-title-component': CardTitleComponent,
            'all-info-pet-component': AllInfoPetComponent,
            'datepicker': Datepicker
        },
        props: ['protegeId', 'protege'],
        data: function () {
            return {
                currentPage: 1,
                perPage: 9999999999,
                filter: '',
                totalRows: 0
            }
        },
        computed: {
            fullname: function () {
                let fullname = ''
                if (this.protege.profile.firstname != null) {
                    fullname = this.protege.profile.firstname + ' '
                }
                if (this.protege.profile.lastname != null) {
                    fullname = fullname + this.protege.profile.lastname
                }
                return fullname
            },
            computedFields: function () {
                let fields = [
                    {key: 'firstname', label: i18n.t('guestlist.resultSection.table.firstnameCol'), sortable: false},
                    {key: 'name', label: i18n.t('guestlist.resultSection.table.lastnameCol'), sortable: false},
                    {key: 'phone', label: i18n.t('guestlist.resultSection.table.phoneCol'), sortable: false, 'class': 'text-center'}
                ]
                return fields
            },
            organDonor: {
                get () { return this.boolToString(this.protege.profile.organDonor) },
                set (value) {}
            },
            patientsProvision: {
                get () { return this.boolToString(this.protege.profile.patientsProvision) },
                set (value) {}
            }
        },
        methods: {
            ...mapActions(PROTEGES_NAMESPACE, {
                loadProtegeAllInfo: PROTEGES_ACTION_GET_PROTEGE_ALL_INFO
            }),
            print: function () {
                let refName = 'printable' + this.protege.profile.id
                this.printElement(this.$refs[refName])
                window.print()
            },
            printElement: function (elem, append, delimiter) {
                let domClone = elem.cloneNode(true)
                let printSection = document.getElementById('printSection')

                if (!printSection) {
                    printSection = document.createElement('div')
                    printSection.id = 'printSection'
                    document.body.appendChild(printSection)
                }

                if (append !== true) {
                    printSection.innerHTML = ''
                } else if (append === true) {
                    if (typeof (delimiter) === 'string') {
                        printSection.innerHTML += delimiter
                    } else if (typeof (delimiter) === 'object') {
                        printSection.appendChlid(delimiter)
                    }
                }
                printSection.appendChild(domClone)
            },
            boolToString: function (boolValue) {
                return (boolValue ? i18n.t('general.true') : i18n.t('general.false'))
            }
        }
    }
</script>

<style lang="scss" scoped>
    .all-info-container {
        /*padding: 40px;*/
    }

    .button-div {
        text-align: right;
    }

    .o-form:disabled {
        background-color: white;
    }

    @media print {
        .o-form:disabled {
            background-color: white;
        }
    }

    @media screen {
        #printable {
            display: none;
        }
    }

    @media screen {
        #printSection {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/guardian/ProtegeAllInfoComponent.vue